var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center",style:({
    'min-height': _vm.$vuetify.breakpoint.smAndUp ? (_vm.fieldHeight + "px") : '0'
  })},[_c('div',[_vm._v(" "+_vm._s(_vm.field.label)+" "),(_vm.field.required)?_c('span',{staticClass:"red--text"},[_vm._v("*")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }